import React from "react"
import clsx from "clsx"

export default class Likert extends React.Component {
	
	constructor(props) {
		super(props);

		this.onChange = this.onChange.bind(this);
	}

	render() {
		var values = this.props.answers.map((answer) => {
			var {id, value} = answer
			var buttonClasses = clsx(this.props.value == id && 'Active')
			
			return <button type="button" key={id} data-value={id} className={buttonClasses} onClick={this.onChange}>{value}</button>
		});

		if (this.props.labels && this.props.labels.length > 0) {
			var labels = this.props.labels.map((label) => {
				// console.log('label', label)
				return <div key={label.position + '_' + label.text}>{label.text}</div>
			});
		}

		return (
			<div className="Likert">
				<div className="Values">{values}</div>
				<div className="Gradient"></div>
				{labels && <div className="Labels">{labels}</div>}
			</div>
		);
	}

	onChange(e) {
		e.stopPropagation();
		e.preventDefault();

		this.props.onChange('LIKERT', this.props.question.id, {options: [{id: e.target.dataset.value}]})
	}

}